export const GET_REPORTS = '/api/reports/getlist'
export const GET_BULK_REPORTS = '/api/reports/getbulklist'
export const BULK_REPORTS_STOP = '/api/reports/stop'
export const BULK_REPORTS_DOWNLOAD = '/api/reports/download'
export const BULK_REPORTS_DOWNLOAD_ALL = '/api/reports/downloadall'
export const BULK_REPORTS_CLEAR = '/api/reports/clear'
export const GET_INDIVIDUAL_REPORTS = '/api/reports/getindividuallist'
export const GET_REPORT = '/api/reports/get'
export const GET_REPORT_PARAMETERS = '/api/reports/getparamters'
export const SAVE_REPORT = '/api/reports/save'
export const UPDATE_REPORT = '/api/reports/update'
export const DELETE_REPORT = '/api/reports/delete'
export const GENERATE_REPORT = '/api/reports/generate'
export const GET_GENERATED_REPORT = '/api/reports/getreportlist'
export const GENERATE_FINISH_REPORT = '/api/reports/finished'
export const STATUS_REPORT = '/api/reports/status'
export const REPORT_MANAGER_LIST = '/api/reports/managers'
export const REPORT_SEND_EMAILS_CHECK = '/api/reports/cansendemails'
export const REPORT_PREVIEW_EMAILS = '/api/reports/PreviewRuleEmails'
export const REPORT_SEND_EMAILS = '/api/reports/SendEmails'
export const REPORT_CONTINUE_SEND_EMAILS = '/api/reports/ContinueWithSending'
export const REPORT_POWER_BI_TOKEN = '/api/account/getpowerbitoken'



// WEBPACK FOOTER //
// ./src/api/reports/types.js